import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  downloadArquivo,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useToast } from '../../../../../../components'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { signAso } from '../../core/_request'
import { useCertificado } from '../../../../../../helpers/hooks/useCertificado'

type Props = {
  atendimento: AtendimentoList
}

export const SignAsoActionsCell: FC<Props> = ({ atendimento }) => {
  const { ensurePassword } = useCertificado()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = `ASO ${atendimento.protocolo ?? ''}`.trim()

  // A senha do certificado já é a confirmação da assinatura (ensurePassword).
  const handleSign = async () => {
    try {
      const { ok, tipo } = await ensurePassword()
      if (!ok || !tipo) return

      showAlertLoading()
      const arquivo = await signAso(Number(atendimento.id), tipo)
      Swal.close()
      downloadArquivo(arquivo)
      showToast({ variant: 'success', title: `${nome} assinado.` })
      // Assinado sai da lista de pendentes.
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return <RowActions itemName={nome} primaryAction={{ label: 'Assinar', onClick: handleSign }} />
}
